<template>
  <div class="footer">
    <div class="son">
      <div class="l">
        <ul class="ul-wrapper">
          <template v-for="(item, index) in navListTop">
            <span class="I" v-if="index">|</span>
            <li class="item">
              <a :href="item.link" v-if="index===0" style="">{{ item.name }}</a>
              <a :href="item.link" v-else target="_blank">{{ item.name }}</a>
            </li>
          </template>
        </ul>
        <ul class="ul-wrapper">
          <template v-for="(item, index) in navlist">
            <span class="I" v-if="index">|</span>
            <li class="item" @click="linkFun(item)">{{ item.name }}</li>
          </template>
        </ul>
        <div class="info">
          <p>版权所有：健康网</p>
          <p>北京东方比特科技有限公司</p>
          <p>
            <el-link href="https://beian.miit.gov.cn" target="_blank" style="color:white" :underline="false">
              京ICP证010450号
            </el-link>
          </p>

          <!-- <p>技术支持：时代创信</p> -->
          <p>京卫网审字：[2001]第22号</p>
          <p>互联网药品信息服务：(京)-经营性-2015-0016</p>
          <p>
            <el-link href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202000260" target="_blank"
                     style="color:white" :underline="false">京公网安备：110102000260
            </el-link>
          </p>
          <p>联系电话：010-68012929</p>
        </div>
      </div>
      <div class="r">
        <img src="../img/acc.jpg">
        <div class="text">健康网微信公众号</div>
      </div>
    </div>
  </div>
</template>
<script>
// import { openHealthSiteWithDbToken } from "@/utils/healthSite";

export default {
  data() {
    return {
      navListTop: [
        {
          name: "数据库",
          link: "/"
        },
        {
          name: "产业经济",
          link: "http://www.healthoo.com/C8/"
        },
        {
          name: "研究报告",
          link: "http://www.healthoo.com/A6/"
        },
        {
          name: "终端市场",
          link: "http://www.healthoo.com/C7/"
        },
        {
          name: "科研信息",
          link: "http://www.healthoo.com/A8/"
        },
        {
          name: "医药原料",
          link: "http://www.healthoo.com/B3/"
        },
        {
          name: "国际药业",
          link: "http://www.healthoo.com/A9/"
        },
        {
          name: "动物用药",
          link: "http://www.healthoo.com/C5/"
        },
        {
          name: "辅料添加剂",
          link: "http://www.healthoo.com/D0/"
        },
        {
          name: "图文报告",
          link: "http://www.healthoo.com/A0/"
        }
      ],
      navlist: [
        {
          name: '首页',
          link: 'http://www.healthoo.com/'
        },
        {
          name: '关于健康网',
          link: 'http://www.healthoo.com/C2/200702/C2_20070227110457_312448.asp'
        },
        {
          name: '联系我们',
          link: 'http://www.healthoo.com/C2/200702/C2_20070227134705_312464.asp'
        },
        {
          name: '入网指南',
          link: 'http://www.healthoo.com/C2/200702/C2_20070227132605_312457.asp'
        },
        {
          name: '隐私条款',
          link: '/clause'
        }
      ],
      path: []
    }
  },
  created() {

  },
  methods: {
    linkFun(e) {
      if (e.name === '首页') {
        this.$router.push({
          path: '/'
        })
      } else if (e.name === '隐私条款') {
        this.$router.push({
          path: '/clause'
        })
      } else {
        var curCrossKey = localStorage.getItem("crossKey");
        var url = e.link || "https://member.healthoo.com/";
        if (curCrossKey && url.indexOf("healthoo.com") > -1) {
          var separator = url.indexOf("?") > -1 ? "&" : "?";
          url += separator + "crossKey=" + encodeURIComponent(curCrossKey);
        } else {
        }
        window.open(url, "_blank")
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import '../styles/size.less';

.footer {
  width: 100%;
  height: 150px;
  background: url("@{footer-bg}") no-repeat center/cover;

  .son {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .l {
      .ul-wrapper {
        display: flex;
        border-bottom: 1px solid #3376ba;
        line-height: 41px;
        .item {
          padding: 0 19px;
          color: @white;
          cursor: pointer;
          &:first-child {
            padding-left: 0;
          }

          &:last-child {
            padding-right: 0;
            border: none;
          }
        }
        a{
          color: @white;
        }
        .I{
          color: @white;
        }
      }

      .info {
        display: flex;
        flex-wrap: wrap;
        width: 690px;
        color: @white;
        margin: 5px 0 0 0;

        p {
          margin: 10px 0 0 18px;

          &:nth-child(1) {
            margin-left: 0
          }

          &:nth-child(5) {
            margin-left: 0
          }
        }
      }
    }

    .r {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        margin: 30px 0 10px;
      }

      .text {
        color: @white;
      }
    }
  }

  .nav-wrapper {
    width: 100%;
    height: 60px;
    box-sizing: border-box;
    border-bottom: 1px solid @dfdfdf;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/footer.vue